import { Injectable, OnDestroy } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { getFirstCalendar, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { Features } from '@ordersnproducts/features';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { CxAlertService } from 'app/shared/cx-alert/cx-alert.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MinimumQuantityValidationCommandService implements OnFieldChanged, OnDestroy {
  private ngDestroy = new Subject();

  constructor(
    private store: Store<OrderBuilderState>,
    private featureToggle: FeatureToggleService,
    private cxAlertService: CxAlertService,
    private translate: TranslateService,
  ) {
    //
  }

  ngOnDestroy(): void {
    this.ngDestroy.next();
  }

  onFieldChanged(
    value: any,
    formGroup: UntypedFormGroup,
    form: ConfigurableFormComponent,
    config: FieldInputNumberConfig,
  ): void {
    const formControl = formGroup.get(config.name);
    this.store
      .select(getFirstCalendar)
      .pipe(
        filter((calendar) => !!calendar),
        take(1),
        map((calendar) => {
          const isRestrictedVolumeEnabled: boolean = this.featureToggle.isFeatureEnabled(
            Features.RESTRICTED_LOAD_SIZE_AND_VOLUME,
          );
          const unit = config.suffix;
          const minVolumeQuantity = calendar.minVolumeQuantity;

          if (isRestrictedVolumeEnabled && minVolumeQuantity && unit) {
            formControl.setValidators([
              (control: AbstractControl) => {
                if (control.value < minVolumeQuantity) {
                  return { min: { min: minVolumeQuantity, unit } };
                }
                return null;
              },
            ]);
          }

          if (isRestrictedVolumeEnabled && value !== 0 && value < minVolumeQuantity) {
            if (!this.cxAlertService.isCwcAlertCreated('min')) {
              this.cxAlertService.createAlert(
                {
                  message: this.translate.instant('views.order.single_catalogs.banner.error.reviewItems'),
                  variant: 'error',
                },
                'min',
              );
              formControl.setErrors({ min: { min: minVolumeQuantity, unit } });
              formControl.markAsTouched();
            }
          }
          formControl.updateValueAndValidity({ emitEvent: false });
        }),
      )
      .subscribe();
  }
}
